import { ACTION_BULK_EXPORT as actionTypes } from '../utils/constants';
import { deleteBulkDownloadJob, getBulkDownloadJobs } from '../services/customBulkExport';
export var handleDeleteJobStatus = function handleDeleteJobStatus(status) {
  return {
    type: actionTypes.DELETE_JOB_SET_STATUS,
    payload: status
  };
};

var clearJobStatus = function clearJobStatus(dispatch) {
  setTimeout(function () {
    dispatch(handleDeleteJobStatus(undefined));
  }, 3000);
};

export var toggleIsExported = function toggleIsExported(status) {
  return {
    type: actionTypes.TOGGLE_IS_EXPORTED,
    payload: status
  };
};
export var toggleCustomBulkExportModal = function toggleCustomBulkExportModal(status) {
  return {
    type: actionTypes.TOGGLE_CUSTOM_BULK_EXPORT_MODAL,
    payload: status
  };
};
export var toggleCustomUploadModal = function toggleCustomUploadModal(status) {
  return {
    type: actionTypes.TOGGLE_CUSTOM_UPLOAD_MODAL,
    payload: status
  };
};
export var onExportTypeChange = function onExportTypeChange(value) {
  return {
    type: actionTypes.CHANGE_EXPORT_TYPE,
    payload: value
  };
};
export var onExportTypeSubmit = function onExportTypeSubmit(value) {
  return {
    type: actionTypes.SUBMIT_EXPORT_TYPE,
    payload: value
  };
};
export var toggleTasksModal = function toggleTasksModal(status) {
  return {
    type: actionTypes.TOGGLE_TASKS_MODAL,
    payload: status
  };
};
export var getTasksInfoComplete = function getTasksInfoComplete(jobs) {
  return {
    type: actionTypes.SET_TASKS_INFO,
    payload: jobs
  };
};
export var deleteJob = function deleteJob(row) {
  return {
    type: actionTypes.DELETE_JOB,
    payload: row
  };
};
export var handleJobDelete = function handleJobDelete(id) {
  return function (dispatch, getState) {
    return deleteBulkDownloadJob(id).then(function () {
      dispatch(deleteJob(id));
      dispatch(handleDeleteJobStatus('success'));
      clearJobStatus(dispatch);
    }).catch(function () {
      dispatch(handleDeleteJobStatus('danger'));
      clearJobStatus(dispatch);
    });
  };
};
export var handleSearchJobsChange = function handleSearchJobsChange(searchString) {
  return {
    type: actionTypes.HANDLE_SEARCH_JOBS_CHANGE,
    payload: searchString
  };
};
export var getTasksInfo = function getTasksInfo() {
  return function (dispatch, getState) {
    dispatch(toggleTasksModal(true));
    return getBulkDownloadJobs().then(function (listOfJobs) {
      var jobs = listOfJobs.map(function (job) {
        var dateSubmitted = job.dateSubmitted;
        job.dateSubmitted = new Date(dateSubmitted);
        return job;
      });
      jobs.sort(function (a, b) {
        return b.dateSubmitted - a.dateSubmitted;
      });
      dispatch(getTasksInfoComplete(jobs));
    }).catch(function (error) {
      dispatch(getTasksInfoComplete(null));
    });
  };
};